import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {useNavigate, NavLink} from "react-router-dom";
import {tokenExpiredLoginAgain,hostUrl, siteUrl, highTrafficInnerPages } from '../constants/global';
import allActions from '../actions/index';
import KnowledgeCenterBucket from '../reducers/KnowledgeCenterBucket';
import { callPageRenderTracking } from './common/Helper';
import CTMain from './sub-components/CT/CTMain';
import CTIcon from '../assets/images/CT-icon.png';


const KnowledgeCenter = () => {

    const queryParams = new URLSearchParams(window.location.search)
    const queryData = queryParams.get("data");

    const knowledgeCenterBucketState =  useSelector(state => state.KnowledgeCenterBucket);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //console.log(knowledgeCenterBucketState, "bucket knowledge center");

    const [spinner, setSpinner] = useState(true);  
    const [responsemessage, setResponseMessage] = useState("");  

    useEffect(() => {
       //console.log('Use Effect call Knowledge center!');

        /******call page render tracking********/
        callPageRenderTracking({page_title:'Knowledge Center',page_link:window.location.href});
        
        // if (knowledgeCenterBucketState.datatrack==1) {
           
        //     //console.log('Use Effect inner Knowledge center!');

        //     /******get data from localstorage*******/
        //     let authlogin = localStorage.getItem('authlogin');
        //     let storageData = authlogin ? JSON.parse(authlogin) : "";
            
        //     var token = 'Bearer '+storageData.token;

        //     const requestOptions = {
        //         method: 'POST',
        //         //mode:'cors',
        //         headers: { 'Content-Type': 'application/json', 
        //         'POST' : '/resource HTTP/1.1',
        //         'Authorization': token,
        //         'Host' : hostUrl
        //         }
        //     };

        //     fetch(siteUrl+'/community-rest-functions.php?action=knowledge_center_page',requestOptions)
        //     .then((response) => response.json())
        //     .then(function(actualData){ 
        //         console.log(actualData, 'got from there');
        //         if(actualData.status=='success'){
        //             dispatch( allActions.KnowledgeCenter.setKnowledgeCenterData(actualData.data));
        //             setSpinner(false);
        //         }else if(actualData.status=='validationerror'){
        //             /*********Push data in data content popup*******/
        //             dispatch( allActions.ModalPopup.showPopup({ popupname:'alertbox', title: tokenExpiredLoginAgain}));
        //             //alert(tokenExpiredLoginAgain);
        //             navigate('/login/?message='+tokenExpiredLoginAgain);
        //             setSpinner(false);
        //         }else{
        //             setSpinner(false);
        //         }
        //     }).catch(rejected => {
        //         //console.log(rejected);
        //         setSpinner(false);
        //         setResponseMessage({status:"error",message:highTrafficInnerPages});
        //     });
            
        // }else{
        //     setSpinner(false);
        // }

    },[knowledgeCenterBucketState]);



    /******Show Message********/
    if(responsemessage){
        return (<div className="fullpage-box"><span className={responsemessage.status}>{responsemessage.message}</span></div>)
    }


    if(queryData){

        /******ClearTrail Data render*******/
        if(queryData==="clear-trail"){
            return <CTMain />
        }

    }

    return (<div className="fullpage-box ">

            <div className="knowledge-button-row">
        
                <div className="knowledge-button-col">
                    <NavLink exact="true" activeclass="active" className="knowledge-button" to="/knowledge-center/?data=clear-trail">
                        <span><img src={CTIcon} alt="" /></span>
                        ClearTrail
                    </NavLink>
                </div>
            </div>
        </div>);




}

export default KnowledgeCenter;